export enum UserRoles {
  ADMIN = 'ADMIN',
  FILE_DOWNLOAD = 'FILE_DOWNLOAD',
  PAGE_STREAMING = 'PAGE_STREAMING',
  KOBO_SYNC = 'KOBO_SYNC'
}

export enum AllowExclude {
  ALLOW_ONLY = 'ALLOW_ONLY', EXCLUDE = 'EXCLUDE'
}
